import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import { Container } from "reactstrap";
import {
  APP_CONST,
  getStoredItem,
  resetStorage,
  isLogin,
  setStoredItem,
} from "@/store/dataStore";
import {
  AppBreadcrumb,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarNav,
} from "@coreui/react";

// sidebar nav config
import nav_manager from "../../navigations/_nav_manager";
import nav_access_manager from "../../navigations/_nav_access_manager";
import nav_authorizer from "../../navigations/_nav_authorizer";
import nav_admin from "../../navigations/_nav_admin";
import nav_auditor from "../../navigations/_nav_auditor";
import nav_re_installation from "../../navigations/_nav_keyholder_re_install";
import nav_registration from "../../navigations/_nav_keyholder_registration";
// routes config
import routes from "../../routes";
import DefaultHeader from "./DefaultHeader";
import DefaultFooter from "./DefaultFooter";
import IdleTimer from "react-idle-timer";
import swal from "sweetalert2";
import endpoints from "@/util/endpoints";
import jwtDecode from "jwt-decode";

class DefaultLayout extends Component {
  state = {
    userInfo: {
      userAccountDTO: {
        firstName: "",
        lastName: "",
        authorities: [""],
      },
    },
    nav_: getStoredItem(APP_CONST.APP_NAV_MENU), // string only
    access_token: getStoredItem(APP_CONST.SEC_TOKEN),
    user_type: getStoredItem(APP_CONST.USER_TYPE),
    user_permissions: JSON.parse(getStoredItem(APP_CONST.USER_PERMISSIONS)),
    user_authorities: JSON.parse(getStoredItem(APP_CONST.USER_AUTHORITIES)),
    user_action: getStoredItem(APP_CONST.CURRENT_ACTION),
    app_nav: "",
    timerInterval: 30000,
  };
  idleTimeOut = window.env.IDLE_TIMEOUT
    ? 1000 * window.env.IDLE_TIMEOUT
    : 1000 * 60 * 15;
  idleTimer = null;
  idleDialog = null;

  /**
   * Check if the user is authorized.
   */
  verifyUser = () => {
    // only allow if there is accessToken available or user is logged in.
    // only userType and Nav matching to allow user proceed
    if (
      getStoredItem(APP_CONST.CURRENT_ACTION) !== APP_CONST.ACTION_REINSTALL
    ) {
      if (this.state.access_token && this.state.user_type && this.state.nav_) {
        // generate current page token
        setStoredItem(APP_CONST.CURRENT_PAGE_TOKEN, window.location.pathname);
        const decodedToken = jwtDecode(this.state.access_token);
        const expireDate = new Date(decodedToken.exp * 1000);
        if (expireDate.getTime() < Date.now()) {
          this.logout();
        }
        return true;
      } else {
        this.logout();
        return false;
      }
    } else {
      return true;
    }
  };

  flattenUrls(data) {
    let urls = [];

    function traverse(obj) {
      if (obj.url) {
        urls.push(obj.url);
      }
      if (obj.children) {
        obj.children.forEach(traverse);
      }
    }

    data.forEach(traverse);

    return urls;
  }

  isAccessDenied() {
    // check with navigation menu when role is custom
    var nav = [];
    nav = this.flattenUrls(this.getMenu().items);
    const routesToRemove = routes
      .map(item => {
        let regex = /\/:\w+/g;
        const parents = item.parents ? item.parents : [];
        return Object.assign(
          {},
          {
            url: item.path.replace(regex, ""),
            isDefault: item.isDefault,
            parents: parents,
          },
        );
      })
      .filter(r => {
        var isParentAccessible =
          r.parents.filter(p => {
            return nav.includes(p);
          }).length > 0;
        var isRemoved = !nav.includes(r.url) && r.isDefault !== true;
        var isActionInstall =
          getStoredItem(APP_CONST.CURRENT_ACTION) ===
            APP_CONST.ACTION_REINSTALL && r.url === "/keyholder/re-install";
        return isRemoved && !isParentAccessible && !isActionInstall;
      });

    var isAccessDenied = false;
    let path = window.location.pathname;

    if (path === "/") {
      if (nav.length > 0) {
        window.location.href = "/blank-page";
      } else {
        this.logout();
      }
      return true;
    }
    routesToRemove.map(route => {
      if (path.includes(route.url)) {
        isAccessDenied = true;
        if (nav.filter(url => path === url).length > 0) isAccessDenied = false;
      }
      return route;
    });
    if (isAccessDenied) window.location.href = "/404";
    return isAccessDenied;
  }

  getNavItems(role) {
    let items;
    switch (role) {
      case "ROLE_ADMINISTRATOR":
        items = nav_admin.items;
        break;
      case "ROLE_MANAGER":
        items = nav_manager.items;
        break;
      case "ROLE_AUTHORIZER":
        items = nav_authorizer.items;
        break;
      case "ROLE_AUDITOR":
        items = nav_auditor.items;
        break;
      case "ROLE_ACCESS_MANAGER":
        items = nav_access_manager.items;
        break;
      default:
        items = [];
        break;
    }
    return items;
  }

  getMenu = () => {
    const nav = { items: [] };
    let app_nav = null;
    if (this.state.user_action === APP_CONST.ACTION_REINSTALL) {
      if (this.state.nav_ === APP_CONST.NAV_RE_INSTALL) {
        app_nav = nav_re_installation;
      }
    } else if (
      this.state.access_token &&
      this.state.user_type &&
      this.state.nav_
    ) {
      if (this.state.nav_ === APP_CONST.NAV_REGISTRATION) {
        app_nav = nav_registration;
      }
    }

    if (app_nav) {
      return app_nav;
    }

    for (let role of this.state.user_authorities) {
      let items = this.getNavItems(role);
      for (let item of items) {
        const index = nav.items.findIndex(i => i.url === item.url);

        if (index !== -1) {
          item.children = item.children || [];
          nav.items[index].children = nav.items[index].children || [];

          for (let childItem of item.children) {
            const childIndex = nav.items[index].children.findIndex(
              i => i.url === childItem.url,
            );
            if (childIndex === -1) {
              nav.items[index].children.push(childItem);
            }
          }
        } else {
          nav.items.push(item);
        }
      }
    }

    const pages = endpoints;

    for (let page of pages) {
      if (page.children) {
        for (let childPage of page.children) {
          const shouldBeAdded =
            childPage.permissions &&
            childPage.permissions.length &&
            childPage.permissions.filter(
              p => !this.state.user_permissions.includes(p),
            ).length === 0;
          let alreadyExists = false;

          for (let item of nav.items) {
            if (alreadyExists) {
              break;
            }
            if (item.url === childPage.url) {
              alreadyExists = true;
              break;
            }

            if (item.children) {
              for (let childItem of item.children) {
                if (childItem.url === childPage.url) {
                  alreadyExists = true;
                  break;
                }
              }
            }
          }

          if (shouldBeAdded && !alreadyExists) {
            let parent = nav.items.find(i => i.url === page.url);
            if (parent) {
              parent.children.push(childPage);
            } else {
              nav.items.push({ ...page, children: [childPage] });
            }
          }
        }
      } else {
        const shouldBeAdded =
          page.permissions &&
          page.permissions.length &&
          page.permissions.filter(p => !this.state.user_permissions.includes(p))
            .length === 0;
        let alreadyExists = false;

        for (let item of nav.items) {
          if (alreadyExists) {
            break;
          }
          if (item.url === page.url) {
            alreadyExists = true;
            break;
          }

          if (item && item.children) {
            for (let childItem of item.children) {
              if (childItem.url === page.url) {
                alreadyExists = true;
                break;
              }
            }
          }
        }

        if (shouldBeAdded && !alreadyExists) {
          nav.items.push(page);
        }
      }
    }

    // check if total accounts is in the nav items
    if (nav.items.filter(item => item.name === "Total Accounts").length > 0) {
      nav.items.push({
        name: "Download",
        listName: "Download",
        url: "/download",
        icon: "fa fa-download fa-lg",
        attributes: { "data-cy": "download" },
      });
    }
    return nav;
  };

  /**
   * Render a sidebar's header
   */
  shouldRenderSideBarHeader = () => {
    if (
      this.state.user_action === APP_CONST.ACTION_REGISTRATION ||
      this.state.user_action === APP_CONST.ACTION_RE_INSTALLATION
    ) {
      return (
        <div className="text-left">
          <p>
            <strong>
              {this.state.userInfo.userAccountDTO.lastName +
                " " +
                this.state.userInfo.userAccountDTO.firstName}
            </strong>
          </p>
          <p>Username: {this.state.userInfo.userAccountDTO.login}</p>
          <p>Role: {this.state.userInfo.userAccountDTO.authorities[0]}</p>
        </div>
      );
    } else {
      return <></>;
    }
  };

  /**
   * Populate the state "userInfo" with stored data.
   */
  settingData = () => {
    this.setState({
      userInfo: JSON.parse(getStoredItem(APP_CONST.USER_INFO)),
    });
  };

  // idle detection
  onAction = e => {
    // refreshing token
    // alert user if session almost expired
  };

  onActive = e => {
    // refreshing token/session
    // this.checkIdleTimer();
  };

  onPageActive = e => {
    const self = this;
    document.addEventListener("visibilitychange", function() {
      self.checkIdleTimer();
      self.checkIfUserChanged();
    });
  };

  checkIfUserChanged = () => {
    const storedToken = getStoredItem(APP_CONST.SEC_TOKEN);
    if (this.state.access_token !== storedToken) {
      window.location.href = "/";
    }
  };

  checkIfInactiveExpired = () => {
    const inactiveDate = getStoredItem(APP_CONST.INACTIVE_DATE);
    if (inactiveDate) {
      let now = new Date();
      const inactive_date = new Date(Number(inactiveDate));
      let differenceInSeconds = now - inactive_date;
      if (differenceInSeconds > this.idleTimeOut) {
        this.logout();
      } else {
        setStoredItem(APP_CONST.INACTIVE_DATE, "");
      }
    }
  };

  checkIdleTimer = () => {
    if (!document.hidden) {
      if (!isLogin()) {
        this.logout();
      } else {
        const isIdleShowed = getStoredItem(APP_CONST.IDLE_SHOWED);
        if (isIdleShowed === "true") {
          this.onIdle();
        } else {
          this.checkIfInactiveExpired();
        }
      }
    } else {
      this.closeIdleDialog();
      const inactiveDate = new Date();
      setStoredItem(APP_CONST.INACTIVE_DATE, inactiveDate.getTime().toString());
    }
  };

  closeIdleDialog = () => {
    swal.close();
    clearInterval(this.state.timerInterval);
  };

  onIdle = e => {
    if (document.hidden) return;
    const timerLeft = getStoredItem(APP_CONST.IDLE_TIMER_LEFT);
    setStoredItem(APP_CONST.IDLE_SHOWED, "true");
    swal({
      title: "You have been idled for too long",
      html: "I will close in <strong></strong> seconds.",
      timer: timerLeft,
      confirmButtonText: "Continue my session",
      cancelButtonText: "Logout now",
      showCancelButton: true,
      onBeforeOpen: () => {
        this.setState({
          timerInterval: setInterval(() => {
            swal.getContent().querySelector("strong").textContent = (
              swal.getTimerLeft() / 1000
            ).toFixed(0);
            setStoredItem(APP_CONST.IDLE_TIMER_LEFT, swal.getTimerLeft());
          }, 100),
        });
      },
    }).then(result => {
      // only this reason will logout other else just ignore.
      const isIdleShowed = getStoredItem(APP_CONST.IDLE_SHOWED);
      if (result.dismiss === "cancel") {
        this.logout();
      } else if (result.dismiss === "timer" && isIdleShowed === "true") {
        if (!document.hidden) {
          this.logout();
        } else {
          setStoredItem(APP_CONST.IDLE_SHOWED, "false");
        }
      }
      setStoredItem(APP_CONST.INACTIVE_DATE, "");
      setStoredItem(APP_CONST.IDLE_SHOWED, "false");
      clearInterval(this.state.timerInterval);
      setStoredItem(APP_CONST.IDLE_TIMER_LEFT, 30000);
    });
  };

  // actions when idleTimer
  logout = () => {
    resetStorage();
    window.location.href = "/login";
  };
  // end idle detection

  componentDidMount() {
    this.onPageActive();
    this.checkIfInactiveExpired();
    setStoredItem(APP_CONST.IDLE_TIMER_LEFT, 30000);
    setStoredItem(APP_CONST.IDLE_SHOWED, "false");
    clearInterval(this.state.timerInterval);
    window.addEventListener("beforeunload", event => {
      const inactiveDate = new Date();
      setStoredItem(APP_CONST.INACTIVE_DATE, inactiveDate.getTime().toString());
    });
  }

  render() {
    // TODO: shouldn't it be called in some lifecycle hook?
    if (this.verifyUser()) {
      if (this.isAccessDenied()) {
        return;
      }

      if (!this.state.user_action === APP_CONST.ACTION_RE_INSTALLATION) {
        this.settingData();
      }

      return (
        <div className="app">
          <AppHeader className="navbar navbar-dark bg-dark" fixed>
            <DefaultHeader history={this.props.history} />
          </AppHeader>
          <IdleTimer
            ref={ref => {
              this.idleTimer = ref;
            }}
            element={document}
            onActive={this.onActive}
            onIdle={this.onIdle}
            onAction={this.onAction}
            debounce={250}
            timeout={this.idleTimeOut}
          />
          <div className="app-body">
            <AppSidebar fixed display="lg">
              <AppSidebarHeader>
                {this.shouldRenderSideBarHeader()}
              </AppSidebarHeader>
              <AppSidebarForm />
              <AppSidebarNav navConfig={this.getMenu()} {...this.props} />
              <AppSidebarFooter />
            </AppSidebar>
            <main className="main">
              <AppBreadcrumb appRoutes={routes} />
              <Container fluid>
                <Switch>
                  {routes.map((route, idx) => {
                    return route.component ? (
                      <Route
                        key={idx}
                        path={route.path}
                        exact={route.exact}
                        name={route.name}
                        render={props => <route.component {...props} />}
                      />
                    ) : null;
                  })}
                  {/* TODO redirect user when login or not */}
                </Switch>
              </Container>
            </main>
          </div>
          <AppFooter>
            <DefaultFooter />
          </AppFooter>
        </div>
      );
    } else {
      this.logout();
      return <div className="app" />;
    }
  }
}

export default DefaultLayout;
